









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PreviewPromotion extends Vue {
  @Prop() readonly url!: string;

  @Prop() readonly description!: string;
}
